/*
|----------------------------------------------------------
|   EventBrite support:
|---------------------------------------------------------
|   All functions related to adding support for Eventbrite
|   embeds to Pjax
|
*/

/**
 * Import config
 */
import config from "./config";

export default {

    /**
     * Append eventbrite widget script for embeds
     */
    appendScript: function() {
        if (config.debug) console.log("appendScript");

        // Append eventbrite script
        var eventBriteScript = document.createElement("script");
            eventBriteScript.type = "text/javascript";
            eventBriteScript.src = "//www.eventbrite.com/static/widgets/eb_widgets.js";
            eventBriteScript.id = "event-brite-script";

        jQuery('.pjax-container').append(eventBriteScript);

    },

    /**
     * IMPORTANT!! THIS FUNCTION IS NOT NEEDED AT THE MOMENT
     * Renders the eventbrite embed into the div
     * container
     */
    renderEmbed: function() {
        if (config.debug) console.log("renderEmbed");

        // get the event container
        var eventContainer = jQuery("[id*='" + config.eventbriteContainerId + "']");

        /**
         * Only process the embed if there's is one in the page or
         * if Elementor didn't rendered it first
         */
        if (eventContainer.length > 0 && jQuery(eventContainer).find('iframe').length == 0) {

            var eventContainerId = jQuery(eventContainer).attr('id');
            var eventId = eventContainerId.replace(config.eventbriteContainerId , '');

            // Makes sure the EBWidgets object is available
            if (window.EBWidgets) {
                var exampleCallback=function(){console.log("Order complete!")};

                // Build the event in the container
                window.EBWidgets.createWidget({
                widgetType:"checkout",
                eventId: eventId,
                iframeContainerId: eventContainerId,
                iframeContainerHeight:425,onOrderComplete:exampleCallback
                });
            }

        }

    }
}
